export default __webpack_public_path__ + "static/media/coins.57c30105.svg";